import { render, staticRenderFns } from "./createplatformCouerse.vue?vue&type=template&id=21a0c394&scoped=true"
import script from "./createplatformCouerse.vue?vue&type=script&lang=js"
export * from "./createplatformCouerse.vue?vue&type=script&lang=js"
import style0 from "./createplatformCouerse.vue?vue&type=style&index=0&id=21a0c394&prod&lang=less&scoped=true"
import style1 from "./createplatformCouerse.vue?vue&type=style&index=1&id=21a0c394&prod&lang=less&scoped=true"
import style2 from "./createplatformCouerse.vue?vue&type=style&index=2&id=21a0c394&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a0c394",
  null
  
)

export default component.exports